import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as ReactivateSiteIconSvg } from '../../../assets/icons/reactivate-site.svg';

export default function ReactivateSiteIcon() {
  return <SvgIcon component={ReactivateSiteIconSvg} viewBox='0 0 26 26'  sx={{ '& path': { fill: 'white' } }} />;
}
